import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { getData } from '../../../api/indexedDBHandler'
import PairComandGroupTournamentProtocolPDF from './PairComandGroupTournamentProtocolPDF'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'

// Выносим логику генерации протокола в отдельную функцию
const generateProtocolData = async (id) => {
  console.log('generateProtocolData', id)
  const resultsU = await getData('teams', 'id', id)
  if (resultsU.length === 0) throw new Error('No team data found')

  const { value: teamValue } = resultsU[0]
  const filteredTeams = Object.values(teamValue).filter(
    (teamEntry) =>
      teamEntry !== null &&
      typeof teamEntry === 'object' &&
      teamEntry.team?.status === 'Заявка одобрена' &&
      teamEntry.team?.status_location === 1
  )

  console.log('filteredTeams', filteredTeams)
  const getnameSp = (team) => {
    //    console.log('[0][0][0][0]', team[0]?.fio)
    const sp1sports_category = team[0]?.sports_category
      ? ' (' + team[0]?.sports_category + ')'
      : ''
    const sp1 = team[0]?.fio ? team[0]?.fio : ''

    const sp2sports_category = team[1]?.sports_category
      ? ' (' + team[1]?.sports_category + ')'
      : ''
    const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

    const sp3sports_category = team[2]?.sports_category
      ? ' (' + team[2]?.sports_category + ')'
      : ''
    const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''

    return (
      sp1 +
      sp1sports_category +
      sp2 +
      sp2sports_category +
      sp3 +
      sp3sports_category
    )
  }

  const resultsS = await getData('stage', 'id', id)
  if (resultsS.length === 0) throw new Error('No stage data found')

  const { value: stageValue } = resultsS[0]
  const stageArray = Object.values(stageValue).filter(
    (teamEntry) => teamEntry !== null && typeof teamEntry === 'object'
  )
  const zones = { А: [], Б: [], В: [] }
  filteredTeams.forEach((teamObj) => {
    const teamData = teamObj.team
    if (teamData.zona && zones[teamData.zona]) {
      zones[teamData.zona].push({
        id: teamData.id,
        name: getname(teamData) || '',
        teamName: teamData.comand_name,
        totalWeight: calculateTotalWeight(teamData.id, stageArray),
        fishCount: calculateFishCount(teamData.id, stageArray),
        biggestFish: calculateBiggestFish(teamData.id, stageArray),
        zona: teamData.zona,
        sp: getnameSp(teamObj.athlete),
        sector: teamData.sector,
        communicationTeams: [
          teamData.communication_team1,
          teamData.communication_team2,
        ].filter(Boolean),
        disqualified: teamData.status === 'Снята',
      })
    }
  })
  console.log('zones', zones)
  const zoneStats = {}
  Object.keys(zones).forEach((zone) => {
    const teamsWithFish = zones[zone].filter((team) => team.totalWeight > 0)
    zoneStats[zone] = {
      lastPlaceWithFish: teamsWithFish.length,
      totalTeams: zones[zone].length,
    }
  })

  Object.keys(zones).forEach((zone) => {
    const [normalTeams, disqualifiedTeams] = zones[zone].reduce(
      ([normal, disq], team) => {
        team.disqualified ? disq.push(team) : normal.push(team)
        return [normal, disq]
      },
      [[], []]
    )

    normalTeams.sort((a, b) => {
      if (a.totalWeight === 0 && b.totalWeight > 0) return 1
      if (a.totalWeight > 0 && b.totalWeight === 0) return -1
      if (a.totalWeight === 0 && b.totalWeight === 0) return 0

      if (b.totalWeight !== a.totalWeight) return b.totalWeight - a.totalWeight

      const avgA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
      const avgB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
      if (avgA !== avgB) return avgB - avgA

      return b.biggestFish - a.biggestFish
    })

    normalTeams.forEach((team, index) => {
      team.zonePlace = team.totalWeight === 0 ? normalTeams.length : index + 1
    })

    disqualifiedTeams.forEach((team) => {
      team.zonePlace = zones[zone].length + 3
    })
    console.log('normalTeamsnormalTeamsnormalTeams', normalTeams)

    zones[zone] = [...normalTeams, ...disqualifiedTeams]
  })
  const teamGroups = []
  const processedTeams = new Set()

  filteredTeams.forEach((teamObj) => {
    const teamId = teamObj.team.id
    if (processedTeams.has(teamId)) return

    const group = findConnectedTeams(teamId, filteredTeams)
    group.forEach((t) => processedTeams.add(t))

    const groupData = group.map((teamId) => {
      const team = findTeamInZones(teamId, zones)
      return {
        id: teamId,
        name: team?.name,
        zone: team?.zona,
        sector: team?.sector,
        place: team?.zonePlace,
        weight: team?.totalWeight,
        fishCount: team?.fishCount,
        biggestFish: team?.biggestFish,
        teamName: team?.teamName,
      }
    })

    const groupTeams = group
      .map((teamId) => findTeamInZones(teamId, zones))
      .filter(Boolean)

    let teamName = ''
    if (groupTeams.some((t) => t.teamName && t.teamName !== '')) {
      teamName = groupTeams.find(
        (t) => t.teamName && t.teamName !== ''
      )?.teamName
    } else {
      teamName = groupTeams.map((t) => t.name).join(' + ')
    }
    console.log('groupData', groupData)
    const totalPlace = groupData.reduce((sum, t) => sum + t.place, 0)

    const totalGroupWeight = groupData.reduce(
      (sum, t) => sum + (t.weight || 0),
      0
    )
    const totalGroupFishCount = groupData.reduce(
      (sum, t) => sum + (t.fishCount || 0),
      0
    )
    const groupBiggestFish = Math.max(
      ...groupData.map((t) => t.biggestFish || 0)
    )

    // Проверяем, что обе пары в команде не поймали рыбу
    const noFishCaught = groupData.every((team) => team.weight === 0)

    teamGroups.push({
      team: teamName,
      teams: groupData,
      totalPlace: totalPlace,
      totalGroupWeight,
      totalGroupFishCount,
      groupBiggestFish,
      athletes: getAllAthletes(group, filteredTeams),
      athletesByZone: groupTeams.reduce((acc, team) => {
        if (!team.zona) return acc // Пропускаем команды без зоны
        if (!acc[team.zona]) acc[team.zona] = []

        // Добавляем либо атлетов, либо всю команду
        if (team.athlete) {
          acc[team.zona].push(
            ...(Array.isArray(team.athlete) ? team.athlete : [team.athlete])
          )
        } else {
          acc[team.zona].push(team)
        }

        return acc
      }, {}),
      noFishCaught,
    })
  })

  // Сортируем команды
  teamGroups.sort((a, b) => {
    // Команды без рыбы идут в конец
    if (a.noFishCaught && !b.noFishCaught) return 1
    if (!a.noFishCaught && b.noFishCaught) return -1
    if (a.noFishCaught && b.noFishCaught) return 0

    // Остальные сортируем по стандартным правилам
    if (a.totalPlace !== b.totalPlace) return a.totalPlace - b.totalPlace
    if (b.totalGroupWeight !== a.totalGroupWeight)
      return b.totalGroupWeight - a.totalGroupWeight
    if (b.totalGroupFishCount !== a.totalGroupFishCount)
      return b.totalGroupFishCount - a.totalGroupFishCount
    return b.groupBiggestFish - a.groupBiggestFish
  })
  // Назначаем места с учетом команд без рыбы
  let currentRank = 1
  const rankedGroups = teamGroups.map((group, index) => {
    if (index > 0) {
      const prevGroup = teamGroups[index - 1]

      // Если текущая группа без рыбы - ставим последнее место
      if (group.noFishCaught) {
        currentRank = teamGroups.length
      }
      // Иначе стандартная логика
      else {
        const isTie =
          prevGroup.totalPlace === group.totalPlace &&
          prevGroup.totalGroupWeight === group.totalGroupWeight &&
          prevGroup.totalGroupFishCount === group.totalGroupFishCount &&
          prevGroup.groupBiggestFish === group.groupBiggestFish

        if (!isTie) currentRank = index + 1
      }
    }
    console.log('group ', group)
    console.log('group.noFishCaught ', group.noFishCaught)
    console.log('teamGroups.length', teamGroups.length)
    console.log('currentRank', currentRank)
    return {
      ...group,
      finalPlace: group.noFishCaught ? teamGroups.length : currentRank,
    }
  })

  const resultsT = await getData('tournaments', 'id', id)
  if (resultsT.length === 0) throw new Error('No tournament data found')

  const { value: tournamentValue } = resultsT[0]
  const isFinish = tournamentValue.status_cup === 'Турнир завершен'
  const allLogos = Object.values(tournamentValue.sponsor || {})
  const administrator = Object.values(tournamentValue.administrator || [])

  function calculateTotalWeight(teamId, stages) {
    return stages[0]
      .filter((s) => s.teamId === teamId)
      .flatMap((s) => s.fishList || [])
      .reduce((sum, fish) => sum + (fish.weight || 0), 0)
  }

  function calculateFishCount(teamId, stages) {
    return stages[0]
      .filter((s) => s.teamId === teamId)
      .flatMap((s) => s.fishList || []).length
  }

  function calculateBiggestFish(teamId, stages) {
    const fishes = stages[0]
      .filter((s) => s.teamId === teamId)
      .flatMap((s) => s.fishList || [])
    return fishes.length ? Math.max(...fishes.map((f) => f.weight || 0)) : 0
  }

  function findConnectedTeams(teamId, teams, found = new Set()) {
    const team = teams.find((t) => t.team.id === teamId)
    if (!team || found.has(teamId)) return []

    found.add(teamId)
    const connections = [
      team.team.communication_team1,
      team.team.communication_team2,
    ].filter(Boolean)

    return [
      teamId,
      ...connections.flatMap((connId) =>
        findConnectedTeams(connId, teams, found)
      ),
    ].filter((v, i, a) => a.indexOf(v) === i)
  }

  function findTeamInZones(teamId, zones) {
    for (const zone of Object.values(zones)) {
      const team = zone.find((t) => t.id === teamId)
      if (team) return team
    }
    return null
  }

  function getAllAthletes(teamIds, teams) {
    return teamIds.flatMap((teamId) => {
      const team = teams.find((t) => t.team.id === teamId)
      return team ? team.athlete : []
    })
  }

  function getname(teamData) {
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }

  return {
    allLogos,
    mainLogo: getLogoUrl(tournamentValue?.logocup),
    data: rankedGroups,
    administrator,
    tournament: tournamentValue,
    date: dateNowProtocol(new Date()),
    totalFishCount: {},
    totalWeight: {},
    averageFishWeight: {},

    biggestFish: {},
    isFinish: isFinish,
    // isFinish,
    // processedData: [], // Замените на ваши обработанные данные
    // totalFishCount: 0, // Замените на реальные значения
    // totalWeight: 0,
    // averageFishWeight: 0,
    // biggestFish: { weight: 0, pair: '' },
  }
}

const DocProtocolPairComandGroup = ({ isProtocolSvodCallback }) => {}
export default {
  generate: async function (id) {
    try {
      const protocolData = await generateProtocolData(id)
      console.log('protocolData', protocolData)
      const pdfDoc = (
        <PairComandGroupTournamentProtocolPDF
          allLogo={protocolData.allLogos}
          mainLogo={getLogoUrl(protocolData.tournament?.logocup)}
          data={protocolData.data}
          administrator={protocolData.administrator}
          tournament={protocolData.tournament}
          date={dateNowProtocol(new Date())}
          totalFishCount={protocolData.totalFishCount}
          totalWeight={protocolData.totalWeight}
          averageFishWeight={protocolData.averageFishWeight}
          biggestFish={protocolData.biggestFish}
          isfinish={protocolData.isFinish}
        />
      )

      const blob = await pdf(pdfDoc).toBlob()
      const url = URL.createObjectURL(blob)

      const servaurl = await uploadPdfToServer(blob, id)
      return {
        blob,
        previewUrl: servaurl,
        data: protocolData,
      }
    } catch (error) {
      console.error('Ошибка при генерации протокола:', error)
      throw error
    }
  },
}
const uploadPdfToServer = async (blob, id) => {
  try {
    const formData = new FormData()
    formData.append(
      'pdf',
      blob,
      `групповой_протокол_${dateNowProtocol(new Date())}.pdf`
    )
    formData.append('id', id)
    formData.append('isPost', 3)

    formData.append('type', 'ProtocolSvodGroup')
    const response = await fetch(
      'https://www.admin-protocarp.ru/php/uploads/upload.php',
      {
        method: 'POST',
        body: formData,
      }
    )

    if (response.ok) {
      const result = await response.json()
      // Обновляем URL на серверный, если нужно
      return { fileUrl: result.fileUrl }
    } else {
      console.error('Ошибка загрузки файла на сервер')
      return { fileUrl: null }
    }
  } catch (error) {
    console.error('Ошибка при загрузке на сервер:', error)
    return { fileUrl: null }
  }
}
